export default {
    'it-IT': {
        latestArrivals: 'Ultimi arrivi',
        latestArrivalsViewAll: 'Scopri tutti gli ultimi arrivi',
        offers: 'Promo',
        offersViewAll: 'Scopri tutte le offerte',
        category: '',
        categoryViewAll: 'Scopri di più',
    },
    'fr-FR': {
        latestArrivals: 'Nouveautés',
        latestArrivalsViewAll: 'Découvrir toutes les nouveautés',
        offers: 'Promo',
        offersViewAll: 'Découvrir toutes les offres',
        category: '',
        categoryViewAll: 'Voir plus',
    },
    'es-ES': {
        latestArrivals: 'Novedades',
        latestArrivalsViewAll: 'Descubre lo último en llegar',
        offers: 'Promo',
        offersViewAll: 'Descubre las ofertas',
        category: '',
        categoryViewAll: 'Descubre más',
    },
    'en-GB': {
        latestArrivals: 'Latest arrivals',
        latestArrivalsViewAll: 'Check out latest arrivals',
        offers: 'Promo',
        offersViewAll: 'Check out all offers',
        category: '',
        categoryViewAll: 'Discover more',
    },
    'en-US': {
        latestArrivals: 'Latest arrivals',
        latestArrivalsViewAll: 'Check out latest arrivals',
        offers: 'Promo',
        offersViewAll: 'Check out all offers',
        category: '',
        categoryViewAll: 'Discover more',
    },
    'de-DE': {
        latestArrivals: 'Neuheiten',
        latestArrivalsViewAll: 'Entdecken Sie all unsere Neuheiten',
        offers: 'Promo',
        offersViewAll: 'Entdecken Sie alle Angebote!',
        category: '',
        categoryViewAll: 'Mehr entdecken',
    },
    'en-AU': {
        latestArrivals: 'Latest arrivals',
        latestArrivalsViewAll: 'Check out latest arrivals',
        offers: 'Promo',
        offersViewAll: 'Check out all offers',
        category: '',
        categoryViewAll: 'Discover more',
    },
    'ko-KR': {
        latestArrivals: '최신 입고 상품',
        latestArrivalsViewAll: '최신 입고 상품 보기',
        offers: 'Promo',
        offersViewAll: '모든 상품 보기',
        category: '',
        categoryViewAll: '',
    },
    'ja-JP': {
        latestArrivals: '新着商品',
        latestArrivalsViewAll: '全ての新着商品を見る',
        offers: 'Promo',
        offersViewAll: 'セール中の商品を全て見る',
        category: '',
        categoryViewAll: '',
    },
};
